export const base_url=process.env.NODE_ENV==='production' ? "" : 'http://localhost:3000/';


export const HomeImages={
	homepage_art:{
	        url:`${base_url}images/homepage-art.png`,  
	},
	/*homepage_art:{
	        url:`${base_url}images/RBO-Home-web.gif`,  
	},*/

	Fox_news:{
	        url:`${base_url}images/Fox_News_Channel_logo.svg`,  
	},

	NBC_news:{
	        url:`${base_url}images/NBC_News_2011.svg`,  
	},

	cbs_news:{
	        url:`${base_url}images/CBS_News.svg`,  
	},

	abc_news:{
	        url:`${base_url}images/abc-news.svg`,  
	},
	authority_magazine:{
	        url:`${base_url}images/authority-magazine.png`,  
	},
	entrepreneur:{
	        url:`${base_url}images/entrepreneur.svg`,  
	},
	home_business:{
	        url:`${base_url}images/home-business.png`,  
	},
	yahoo_finance:{
	        url:`${base_url}images/yahoo-finance.svg`,  
	},
	thrive_global:{
	        url:`${base_url}images/thrive-global.png`,  
	},
	martech_series:{
	        url:`${base_url}images/martech-series.svg`,  
	},	
}

export const googleAddSense={
	highest_paying : {
			url:`${base_url}images/highest-paying.png`
	},
	ribht_audience : {
			url:`${base_url}images/ribht-audience.png`
	},
}

export const socialWebTalk={
	save_time_money : {
			url:`${base_url}images/save-time-money.svg`
	},
	
	earn_your_time : {
			url:`${base_url}images/earn-from-your-time.svg`
	},
	earnings_1 : {
			url:`${base_url}images/earnings-1.svg`
	},
	likes : {
			url:`${base_url}images/likes.svg`
	},
	comments : {
			url:`${base_url}images/comments.svg`
	},
	share : {
			url:`${base_url}images/share.svg`
	},
}








